globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.ContactsImportText = (function(superClass) {

  utils.extend(ContactsImportText, superClass);

  function ContactsImportText() {
    return ContactsImportText.__super__.constructor.apply(this, arguments);
  }

  $.extend(ContactsImportText.prototype, {
    init: function() {
      var modal = this;
      var $modal = $('.modal');
      var $formContainer = $modal.find('.crm-import-contacts-text-form');
      var $textarea = $formContainer.find('.text-area-import-textarea');
      var $submitBtn = $formContainer.find('.modal-submit-btn');
      var $optInInput = $formContainer.find('input[name="emailing_opt_in_declared_by_user"]');

      appCustomerSpace.LimitlessPlugins.Selects.Single.init(modal.$html);

      $textarea.on('input', function() {
        var $textareaEl = $(this);
        var value = $textareaEl.val();
        if(value.trim() != '' && $optInInput.is(':checked')) {
          $submitBtn.removeAttr('disabled');
        } else {
          $submitBtn.attr('disabled', true);
        }
      });

      $optInInput.on('change', function() {
        var $input = $(this);
        if($input.is(':checked') && $textarea.val().trim() != '') {
          $submitBtn.removeAttr('disabled');
        } else {
          $submitBtn.attr('disabled', true);
        }
      });

      $modal.on('click', '.modal-submit-btn', function(e) {
        e.preventDefault();
        appCustomerSpace.Loader().start({ $container: modal.$html.find('.modal-content') });
        var $body = $('body');
        var $html = $body.find('.crm-import-contact-xlsx');
        var $btn = $(e.target);
        var form = $btn.closest('form')
        var url = form.attr('action');

        $.ajax({
          type: "POST",
          url: url,
          data: new FormData(form[0]),
          processData: false,
          contentType: false,
          success: function(data) {
            if(data.response && data.html) {
              appCustomerSpace.Loader().stop();
              modal.close(function(){
                appCustomerSpace.Modal.mountCurrentModal($(data.html)).open({});
              });
            } else {
              alert("Une erreur est survenue lors de l'importation des contacts");
            }
          }
        });
      })

      return ContactsImportText.__super__.init.apply(this, arguments);
    }
  });

  return ContactsImportText;

})(appCustomerSpace.Modal);
